<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M16 29.333c7.364 0 13.334-5.97 13.334-13.334 0-7.363-5.97-13.333-13.334-13.333-7.363 0-13.333 5.97-13.333 13.333 0 7.364 5.97 13.334 13.333 13.334zm5.04-15.585a1 1 0 10-1.414-1.414l-5.201 5.202-2.05-2.05A1 1 0 1010.96 16.9l2.757 2.757a1 1 0 001.415 0l5.909-5.909z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'symbolsCircleCheckFilled'
}
</script>
